import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs';

import { selectIsAuthenticated, selectRestored } from '../store/auth.selectors';

/** Wait until `Restore Session` has settled before deciding activation. */
function whenRestored() {
  const store = inject(Store);
  return store.select(selectRestored).pipe(
    filter((restored) => restored),
    take(1),
  );
}

/** Protects the main shell; redirects unauthenticated users to /auth. */
export const authGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return whenRestored().pipe(
    switchMap(() => store.select(selectIsAuthenticated).pipe(take(1))),
    map((isAuthenticated) => (isAuthenticated ? true : router.createUrlTree(['/auth']))),
  );
};

/** Bounces already-authenticated users away from the auth route. */
export const anonymousGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return whenRestored().pipe(
    switchMap(() => store.select(selectIsAuthenticated).pipe(take(1))),
    map((isAuthenticated) => (isAuthenticated ? router.createUrlTree(['/']) : true)),
  );
};
